/* A brief contact-sheet reveal. The photograph is fully visible without JavaScript. */
(() => {
  if (window.wilgoodExhibitionMotion || !('IntersectionObserver' in window)) return
  window.wilgoodExhibitionMotion = true

  const preference = window.matchMedia('(prefers-reduced-motion: reduce)')
  const selector = '[data-exhibition-story] .exhibition-story__media'
  let observed = new WeakSet()
  const revealed = new WeakSet()
  const active = new Map()

  const observer = new IntersectionObserver((entries) => {
    let position = 0
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting || revealed.has(target)) return
      observer.unobserve(target)
      revealed.add(target)
      if (preference.matches || typeof target.animate !== 'function') return
      const animation = target.animate([
        { clipPath: 'inset(0 0 9% 0)' },
        { clipPath: 'inset(0 0 0 0)' },
      ], {
        duration: 680,
        delay: Math.min(position++, 1) * 90,
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
      })
      active.set(target, animation)
      const finish = () => active.delete(target)
      animation.addEventListener('finish', finish, { once: true })
      animation.addEventListener('cancel', finish, { once: true })
    })
  }, { threshold: 0.12 })

  function initialize(scope = document) {
    if (preference.matches) return
    scope.querySelectorAll(selector).forEach((photo) => {
      if (observed.has(photo) || revealed.has(photo)) return
      observed.add(photo)
      observer.observe(photo)
    })
  }

  preference.addEventListener('change', () => {
    if (preference.matches) {
      observer.disconnect()
      observed = new WeakSet()
      active.forEach((animation) => animation.cancel())
    } else {
      initialize()
    }
  })
  document.addEventListener('shopify:section:load', (event) => initialize(event.target))
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((photo) => {
      observer.unobserve(photo)
      active.get(photo)?.cancel()
    })
  })
  initialize()
})()
